import React, { Component } from 'react';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import Slide from 'material-ui/transitions/Slide';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

class VoteList extends Component {

    handleRequestClose = () => {
        this.props.closeDialog();
    };

    render() {
        const { data } = this.props;
        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Resolution Votes Details</span>
                    </DialogTitle>
                    <DialogContent>
                        {!data ? null :
                            <div className="row p-2">
                                <div className="col-md-4 p-2">
                                    Resolution Name :
                                </div>
                                <div className="col-md-6 p-2">
                                    {data.name}
                                </div>
                                <div className="col-md-4 p-2">
                                    YES :
                                </div>
                                <div className="col-md-6 p-2">
                                    {data.yes}
                                </div>
                                <div className="col-md-4 p-2">
                                    NO :
                                </div>
                                <div className="col-md-6 p-2">
                                    {data.no}
                                </div>
                                <div className="col-md-4 p-2">
                                    Abstain :
                                </div>
                                <div className="col-md-6 p-2">
                                    {data.abstain}
                                </div>

                                <div className="col-md-12">
                                    <div className="table-responsive-material">
                                        <table className="default-table table-unbordered table table-lg table-hover">
                                            <thead className="th-border-b">
                                                <tr>
                                                    <th>#</th>
                                                    <th>User</th>
                                                    <th>Vote Type</th>
                                                    <th>Comment</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.votes && data.votes.length > 0 ?
                                                    data.votes.map((_data, index) => {
                                                        return (
                                                            <tr tabIndex={-1} key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{_data.user_id}</td>
                                                                <td>{_data.votetype}</td>
                                                                <td>{_data.comment}</td>
                                                            </tr>
                                                        );
                                                    })
                                                    :
                                                    <tr tabIndex={-1} key={0}><td colSpan="4">No data found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
export default VoteList;


// WEBPACK FOOTER //
// ./app/resolutiondetails/resolutionlist/votelist.js